import { atom } from 'jotai';

const activeRoutesAvailableAtom = atom(false);

export default activeRoutesAvailableAtom;
